import React from 'react';
import type { ReactNode } from 'react';
import { ButtonV2 } from '@withjoy/joykit';
import type { ButtonV2Props } from '@withjoy/joykit';

type InlineLinkButtonProps = Readonly<{
  children: ReactNode;
  onClick: ButtonV2Props['onClick'];
}>;

/**
 * A link-styled button for inline text navigation.
 * Renders as an underlined, ghost-style button that fits naturally within text flow.
 */
export const InlineLinkButton = ({ children, onClick }: InlineLinkButtonProps) => {
  return (
    <ButtonV2
      onClick={onClick}
      typographyVariant="body2"
      css={{ 'text-underline-offset': '20%', 'text-underline-position': 'from-font' }}
      intent="newPrimary"
      variant="ghost"
      overrides={{
        Root: {
          props: {
            padding: 0,
            paddingX: 0,
            height: 'auto',
            marginLeft: 3,
            textDecoration: 'underline',
            textDecorationStyle: 'dotted',
            display: { _: 'block', sm2: 'inline-block' },
          },
        },
      }}
    >
      {children}
    </ButtonV2>
  );
};
